import { AxiosInstance } from 'axios';

export class JSONConfigService {
  private agent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }
  public getConfig = async () => {
    let { data } = await this.agent.get('');
    return data;
  };
}
